import type { NextRouter } from 'next/router';

import { fullPageLoad } from './fullPageLoad';
import { isZbidIssuingRoute } from './ownedRoutes';

/**
 * Goes to `href` the way `router.push` does, except that a page which issues
 * `__Host-zbid` gets a full page load. A client-side route change only fetches
 * `/_next/data`, which never sets the cookie, so the login or signup form would
 * submit without it. Use this instead of calling `router.push` or
 * `router.replace` directly; lint enforces that.
 */
export function navigateWithinApp(router: NextRouter, href: string) {
  if (isZbidIssuingRoute(href)) {
    fullPageLoad(href);
    return;
  }
  // eslint-disable-next-line no-restricted-syntax -- this is the one place the router is called
  void router.push(href);
}
